import { delay } from "motion/react"
import { create } from "zustand"

export type CmdkPage =
	| "Customers"
	| "People"
	| "SLAs"
	| "SpawnAgent"
	| "OpenInClaudeCode"
	| "GenerateDocs"
	| "DocGaps"
	| "Importance"
	| "Assign to"
	| "Tags"
	| "Contact"
	| "Company"
	| "Merge into"
	| "Merge company"
	| "Merge person"
	| "Switch workspace"

interface CmdkState {
	isOpen: boolean
	setIsOpen: (value: boolean) => void
	commandText: string
	setCommandText: (value: string) => void
	pages: Array<CmdkPage>
	page: CmdkPage | undefined
	addPage: (value: CmdkPage) => void
	removePage: () => void
	/** Opened straight onto a page by a shortcut ("o w"), so Escape closes instead of going back. */
	openedOnPage: boolean
	openPage: (value: CmdkPage) => void
	isCreateProjectOpen: boolean
	setIsCreateProjectOpen: (value: boolean) => void
	mergeCompanyWithId: string | null
	openMergeCompanyDialog: (withId: string) => void
	clearMergeCompanyDialog: () => void
	mergeContactWithId: string | null
	openMergeContactDialog: (withId: string) => void
	clearMergeContactDialog: () => void
}

export const useCmdkState = create<CmdkState>()((set) => ({
	isOpen: false,
	setIsOpen: (value) => {
		if (value) {
			set({ isOpen: true })
			return
		}
		set({
			isOpen: false,
			pages: [],
			page: undefined,
			commandText: "",
			openedOnPage: false,
		})
	},
	commandText: "",
	setCommandText: (value) => {
		set({ commandText: value })
	},
	pages: [],
	page: undefined,
	addPage: (value) => {
		set((prev) => ({
			pages: [...prev.pages, value],
			page: value,
			commandText: "",
			openedOnPage: false,
		}))
	},

	removePage: () => {
		set((prev) => {
			const newPages = prev.pages.slice(0, -1)
			return { pages: newPages, page: newPages[newPages.length - 1] }
		})
	},
	openedOnPage: false,
	openPage: (value) => {
		set({
			isOpen: true,
			pages: [value],
			page: value,
			commandText: "",
			openedOnPage: true,
		})
	},
	isCreateProjectOpen: false,
	setIsCreateProjectOpen: (value) => {
		if (value) {
			set({
				isOpen: false,
				pages: [],
				page: undefined,
				commandText: "",
			})
			delay(() => {
				set({ isCreateProjectOpen: true })
			}, 100)
		} else {
			set({ isCreateProjectOpen: false })
		}
	},
	mergeCompanyWithId: null,
	openMergeCompanyDialog: (withId) => {
		set({
			isOpen: false,
			pages: [],
			page: undefined,
			commandText: "",
		})
		delay(() => {
			set({ mergeCompanyWithId: withId })
		}, 100)
	},
	clearMergeCompanyDialog: () => {
		set({ mergeCompanyWithId: null })
	},
	mergeContactWithId: null,
	openMergeContactDialog: (withId) => {
		set({
			isOpen: false,
			pages: [],
			page: undefined,
			commandText: "",
		})
		delay(() => {
			set({ mergeContactWithId: withId })
		}, 100)
	},
	clearMergeContactDialog: () => {
		set({ mergeContactWithId: null })
	},
}))
